import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PageBase, T4TurboOrderService, ViewPriceListModel, ViewPriceListRowModel, T4ListItem } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CustomerInfo } from '../../components/CustomerInfo/CustomerInfo.component';

@Component({
  selector: 't4order-pricelist',
  templateUrl: './EditPricelist.html',
  styleUrls: ['./EditPricelist.css']
})
export class EditPricelistComponent extends PageBase implements OnInit {

  @ViewChild("tblEditPricelist", { static: false }) tblEditPricelist: T4DatatableWidget;
  public pricelist: ViewPriceListModel;
  public pricelistRow: ViewPriceListRowModel[];
  public updatedPricelistRow: any[];
  public pricelistId;
  public searchTextGroup: string = '';
  public groups: any[] = [];
  public filteredGroups: any[] = [];
  public selectedGroupId: number = 0;

  constructor(el: ElementRef, private router: Router, private route: ActivatedRoute, public dialog: MatDialog, private orderSvc: T4TurboOrderService) {
    super(el, "Order");
  }

  async ngOnInit() {
    await this.loadRentalLocationGroups();
    this.route.params.subscribe(async params => {
      if (params.Id) {
        this.pricelistId = params.Id;
        await this.GetPricelist(params.Id);
        await this.setSelectedGroupFromMapping();
      } else {
      }
    });
  }

  public async GetPricelist(id) {
    var x = await this.Api.get<ViewPriceListModel>("/TurboOrder/GetPriceList", { id: id });
    if (x)
      this.pricelist = x;
    this.pricelist.Type = this.pricelist.Type ?? "";
    this.pricelistRow = this.pricelist.Rows;
    this.updatedPricelistRow = this.pricelistRow.map(item => ({
      ...item,
      isSalesPrice: item.SalesPrice != 0.00,
      isServiceFee: item.ServiceFee != 0.00,
      isConceptFee: item.ConceptFee != 0.00
    }));
  }

  public getSum(salesPrice: number, serviceFee: number, conceptFee: number): number {
    //this.pricelist.Fees = Number(conceptFee) > 0 && Number(serviceFee) > 0 ? "Service & Concept" : Number(conceptFee) > 0 && Number(serviceFee) == 0 ? "Concept" : Number(conceptFee) == 0 && Number(serviceFee) > 0 ? "Service" : "None";
    return Number(salesPrice) + Number(serviceFee) + Number(conceptFee);
  }

  public async savePricelist() {
    var x = await this.UI.confirm(
      "TO.EditPriceList.headConfirmSave",
      "Save Pricelist?",
      "TO.EditPriceList.msgConfirmSave",
      "Are you sure you want to save the updated pricelist?");
      
    if (!x) return;

    var token = this.UI.beginLoading("TO.EditPriceList.msgUpdatingPricelist", "Saving Pricelist", null);
    //this.pricelist.Fees = what if there are some rows with service or concept and some with not.
    /*this.pricelist.Rows = this.updatedPricelistRow.map(item => ({
      Id: item.Id,
      PriceListId: item.PriceListId,
      ArticleNo: item.ArticleNo,
      Description: item.Description,
      PricePerMonth: Number(item.SalesPrice) + Number(item.ServiceFee) + Number(item.ConceptFee),
      SalesPrice: item.SalesPrice,
      ServiceFee: item.ServiceFee,
      ConceptFee: item.ConceptFee
    }));*/
    var ret = await this.Api.post<boolean>("TurboOrder/SavePricelist", this.pricelist, {});
    
    if (!ret) {
      this.UI.alert(
        "TO.EditPriceList.headSavePricelistFailed",
        "Pricelist could not be saved", "",
        null);
      this.UI.loaderCompleted(token);
      return;
    }

    var mappingSaved = await this.createMapping();

    if (mappingSaved) {
      this.UI.snackBar("Pricelist saved successfully!", null, 3000);
    } else {
      this.UI.alert(
        "TO.EditPriceList.headSavePricelistFailed1",
        "Pricelist saved, but group mapping could not be saved", "",
        null);
    }
    this.UI.loaderCompleted(token);
  }

  private async setSelectedGroupFromMapping() {
    if (!this.pricelist?.Title) {
      this.selectedGroupId = 0;
      return;
    }

    const groupId = await this.Api.get<number>("TurboOrder/GetGroupMappingForPricelist", { priceList: this.pricelist.Title });
    this.selectedGroupId = Number(groupId ?? 0);
  }

  private async loadRentalLocationGroups() {
    const allGroups = await this.Api.get<T4ListItem[]>("TurboOrder/GetAllGroups");
    this.groups = allGroups.map(x => ({ ...x, Id: Number(x.Id)}));
    this.filteredGroups = this.groups;

  }

  public async onGroupSelectionChanged(value: number) {
    this.selectedGroupId = value;
  }

  public resetSearch(opened: boolean, type: string) {
    if (!opened) {
      this.searchTextGroup = '';
      this.filteredGroups = this.groups;
    }
  }

  public filterGroups() {
    const search = this.searchTextGroup?.toLowerCase() ?? '';
    this.filteredGroups = this.groups.filter(group => group.Name?.toLowerCase().includes(search));
  }

  public async createMapping() : Promise<boolean> {
    return await this.Api.get<boolean>("TurboOrder/SaveGroupMapping", { groupId: this.selectedGroupId, priceList: this.pricelist.Title });
  }
}
